<template>
  <div>
    <div class="container-fluid">
      <div class="content_page">
        <div class="detail_conditions_popup">
          <div class="head_conditions_login_2">
            <div id="heading1" class="head_conditions_login">
              <h3>
                <strong>การคุ้มครองข้อมูลส่วนบุคคล</strong>
                <br />
                <strong>(Privacy Notice)</strong>
              </h3>
            </div>
            <div id="consentView" class="container-fluid">
              <p>
                <strong><u>กรอบนโยบาย</u></strong>
              </p>
              <p>
                บริษัท สมิติเวช จำกัด (มหาชน)
                มุ่งมั่นที่จะคุ้มครองข้อมูลส่วนบุคคลของท่านในฐานะที่ท่านเป็นผู้เข้ารับบริการตรวจ
                รักษาโรค และบริการทางการแพทย์ รวมถึงบริการต่างๆ จากบริษัทฯ
                ข้อมูลส่วนบุคคลของท่านจะได้รับการคุ้มครองตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                พ.ศ. 2562 บริษัทฯ
                ในฐานะผู้ควบคุมข้อมูลส่วนบุคคลมีหน้าที่ตามกฎหมายในการแจ้งเอกสารฉบับนี้ให้ท่านทราบถึงเหตุผลและวิธีการที่บริษัทฯ
                เก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
                รวมถึงแจ้งให้ท่านทราบสิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล
              </p>
              <p>
                <strong><u>วัตถุประสงค์</u></strong>
              </p>
              <p>
                บริษัทฯ
                ประมวลผลข้อมูลส่วนบุคคลของท่านภายใต้ขอบเขตที่กำหนดไว้โดยพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                พ.ศ. 2562
                และประมวลผลข้อมูลเพียงเท่าที่จำเป็นสำหรับการดำเนินการดังกล่าว
                โดยบริษัทฯ ได้สรุปการใช้ข้อมูลส่วนบุคคลของท่าน
                พร้อมทั้งอธิบายฐานการประมวลผลข้อมูลส่วนบุคคลที่ชอบด้วยกฎหมาย
                (Lawful Basis of Processing) ดังนี้
              </p>
              <table>
                <thead>
                  <tr>
                    <th width="33">
                      <p>
                        <strong></strong>
                      </p>
                    </th>
                    <th width="275">
                      <p>
                        <strong>วัตถุประสงค์</strong>
                      </p>
                    </th>
                    <th width="144">
                      <p>
                        <strong>ประเภทข้อมูล</strong>
                        <strong></strong>
                      </p>
                    </th>
                    <th width="149">
                      <p>
                        <strong>ฐานการประมวลผลที่ชอบด้วยกฎหมาย</strong>
                      </p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="33" valign="top">
                      <p>
                        <strong>1.</strong>
                      </p>
                    </td>
                    <td width="275" valign="top">
                      <p>
                        <strong>
                          เพื่อวัตถุประสงค์ในการตรวจรักษาโรคและให้บริการทางการแพทย์
                        </strong>
                      </p>
                      <p>
                        <strong
                          >1.1
                          การให้บริการทางการแพทย์ภายในสถานพยาบาลของบริษัทฯ</strong
                        >
                      </p>
                      <p>
                        คณะแพทย์ พยาบาล และ/หรือ บุคลากรอื่นๆ
                        ในทีมสุขภาพของบริษัทฯ
                        จะทำการบันทึกข้อมูลส่วนบุคคลของท่าน
                        นำข้อมูลส่วนบุคคลของท่านเพื่อปรึกษาแพทย์หรือบุคลากรทางการแพทย์
                        รวมถึงถ่ายภาพนิ่งและภาพเคลื่อนไหว เพื่อติดตามการรักษา
                        และ/หรือ กระทำการใดๆ
                        ตามหลักวิชาชีพที่เกี่ยวข้องตลอดระยะเวลาที่ท่านเข้ารับบริการ
                        โดยบริษัทฯ
                        จะอธิบายข้อมูลรายละเอียดให้ท่านได้เข้าใจก่อนที่จะดำเนินการ
                        อีกทั้งเปิดโอกาสให้ท่านซักถามจนเป็นที่พอใจ
                      </p>
                      <p>
                        <strong
                          >1.2
                          การให้บริการทางการแพทย์ในกรณีจำเป็นต้องเชื่อมโยงข้อมูลระหว่างสถานพยาบาลในเครือข่าย</strong
                        >
                      </p>
                      <p>
                        เพื่อประโยชน์ในการให้บริการทางการแพทย์แก่ท่าน คณะแพทย์
                        พยาบาล และ/หรือ บุคลากรอื่นๆเกี่ยวข้องของบริษัทฯ
                        อาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้สถานพยาบาลในเครือข่ายในกรณีที่จำเป็นต้องใช้ข้อมูลระหว่างสถานพยาบาลในเครือข่ายเพื่อการให้บริการบางประเภท
                        ทั้งนี้ บริษัทฯ
                        ได้จัดให้มีมาตรการคุ้มครองข้อมูลส่วนบุคคลโดยมีข้อตกลงร่วมกันระหว่างสถานพยาบาลในเครือข่ายเพื่อป้องกันไม่ให้เกิดการประมวลผลข้อมูลส่วนบุคคลของท่านในทางที่มิชอบด้วยกฎหมาย
                        หรือโดยปราศจากอำนาจ
                      </p>
                      <p>
                        <strong
                          >1.3 เพื่อรับ - ส่งต่อผู้ป่วยระหว่างสถานพยาบาล
                          (Refer)</strong
                        >
                      </p>
                      <p>
                        ในกรณีที่บริษัทฯ
                        มีคำร้องขอหรือได้รับการร้องขอให้เคลื่อนย้ายผู้ป่วยจากสถานพยาบาลหนึ่ง
                        เพื่อไปรับการตรวจรักษาต่อที่สถานพยาบาลอื่น
                        หรือมีคำร้องขอหรือได้รับคำร้องขอให้รับผู้ป่วยจากสถานพยาบาลหนึ่งเพื่อเข้ารับการรักษาในสถานพยาบาลของบริษัทฯ
                        ตามกระบวนการรับ-ส่งต่อผู้ป่วยระหว่างสถานพยาบาล (Refer)
                        บริษัทฯ
                        จะต้องดำเนินตามกระบวนการรับ-ส่งต่อผู้ป่วยที่กำหนดไว้ตามมาตรฐานของบริษัทฯ
                        และจะใช้ข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ในการรับ-ส่งต่อผู้ป่วยเท่านั้น
                        ไม่นำไปใช้ในวัตถุประสงค์อื่น
                      </p>
                    </td>
                    <td width="144" valign="top">
                      <p>- ข้อมูลระบุตัวตน</p>
                      <p>- ข้อมูลสำหรับการติดต่อ</p>
                      <p>- ข้อมูลด้านสุขภาพ</p>
                      <p>- ข้อมูลการเงิน</p>
                    </td>
                    <td width="149" valign="top">
                      <p>
                        1.
                        เป็นการจำเป็นเพื่อการปฏิบัติตามสัญญาเข้ารับการรักษาพยาบาลที่ท่านเป็นคู่สัญญากับบริษัทฯ
                        (ม.24 (3))
                      </p>
                      <p>
                        2. สำหรับข้อมูลส่วนบุคคลที่อ่อนไหว:
                        ฐานปฏิบัติตามกฎหมายในการวินิจฉัยโรคและการรักษาทางการแพทย์
                        เช่น พระราชบัญญัติสถานพยาบาล พ.ศ. 2541 และ
                        พระราชบัญญัติวิชาชีพเวชกรรม พ.ศ. 2525 (ม.26 (5) (ก))
                      </p>
                      <p>
                        3. สำหรับข้อมูลส่วนบุคคลที่อ่อนไหว:
                        เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย
                        หรือสุขภาพในกรณีที่เจ้าของข้อมูลส่วนบุคคลไม่สามารถให้ความยินยอมได้
                        เช่น การเข้ารับบริการในกรณีฉุกเฉิน (Emergency Care)
                        หรือเพื่อรับ - ส่งต่อผู้ป่วยระหว่างโรงพยาบาล (Refer)
                        (ม.26 (1))
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="33" valign="top">
                      <p>
                        <strong>2.</strong>
                      </p>
                    </td>
                    <td width="275" valign="top">
                      <p>
                        <strong>
                          เพื่อวัตถุประสงค์ในการศึกษาวิเคราะห์เพื่อพัฒนาคุณภาพของการรักษาพยาบาลโดยไม่บ่งชี้ตัวตนของเจ้าของข้อมูลส่วนบุคคล
                        </strong>
                      </p>
                      <p>
                        บริษัทฯ
                        อาจนำข้อมูลส่วนบุคคลของท่านไปใช้เพื่อการศึกษาวิเคราะห์เพื่อการพัฒนาคุณภาพของการรักษาพยาบาล
                        โดยจะทำเป็นรูปแบบรายงานผลโดยภาพรวมที่ไม่มีการบ่งชี้ตัวตนของเจ้าของข้อมูล
                        และบริษัทฯ
                        จะรักษาความลับของข้อมูลดังกล่าวของท่านอย่างเคร่งครัด
                      </p>
                    </td>
                    <td width="144" valign="top">
                      <p align="center">ข้อมูลสถิติ</p>
                    </td>
                    <td width="149" valign="top">
                      <p>
                        เพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัท (Legitimate
                        Interest)
                        ในการวิเคราะห์ข้อมูลสถิติโดยไม่ใช้ข้อมูลส่วนบุคคลที่ระบุตัวตนได้เพื่อพัฒนาและเพิ่มประสิทธิภาพขององค์กรในด้านการรักษาพยาบาล
                        และการให้บริการต่างๆ ของบริษัทฯ (ม.24 (5))
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="33" valign="top">
                      <p>
                        <strong>3.</strong>
                      </p>
                    </td>
                    <td width="275" valign="top">
                      <p>
                        <strong>
                          การเปิดเผยข้อมูลให้บริษัทประกันภัยที่ท่านหรือบริษัทฯ
                          เป็นคู่สัญญาเพื่อวัตถุประสงค์ในการใช้สิทธิเรียกค่าสินไหมทดแทนจากบริษัทประกันภัยหรือใช้สิทธิเบิกค่ารักษาพยาบาล
                        </strong>
                      </p>
                      <p>
                        บริษัทจำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของท่านให้บริษัทประกันภัยเพื่อการปฏิบัติตามสัญญาที่ท่านหรือบริษัทฯ
                        ได้ทำไว้กับบริษัทประกันภัย
                        เพื่อประโยชน์ในการเบิกจ่ายค่าสินไหมทดแทนหรือใช้สิทธิเบิกค่ารักษาพยาบาล
                        ทั้งนี้ บริษัทฯ
                        จะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่นใดที่ไม่เกี่ยวข้อง
                      </p>
                    </td>
                    <td width="144" valign="top">
                      <p>- ข้อมูลระบุตัวตน</p>
                      <p>- ข้อมูลสำหรับการติดต่อ</p>
                      <p>- ข้อมูลด้านสุขภาพ</p>
                    </td>
                    <td width="149" valign="top">
                      <p>
                        เมื่อได้รับความยินยอมโดยชัดแจ้งจากท่านในการเปิดเผยข้อมูลส่วนบุคคลที่เป็นข้อมูลด้านสุขภาพให้บริษัทประกันภัยเพื่อประโยชน์ในการใช้สิทธิเรียกค่าสินไหมทดแทนจากบริษัทประกันภัยหรือใช้สิทธิเบิกค่ารักษาพยาบาล
                        (ม.26)
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="33" valign="top">
                      <p>
                        <strong>4.</strong>
                      </p>
                    </td>
                    <td width="275" valign="top">
                      <p>
                        <strong>
                          การเปิดเผยข้อมูลให้ผู้ที่ส่งท่านมาตรวจหรือเป็นผู้ชำระเงินเมื่อท่านได้ยินยอมให้เปิดเผยข้อมูลส่วนบุคคล
                        </strong>
                      </p>
                      <p>
                        ในกรณีที่หน่วยงานไม่ว่าภาครัฐ เอกชน
                        หรือรัฐวิสาหกิจเป็นผู้ส่งท่านมาตรวจรักษากับบริษัทฯ
                        หรือเป็นผู้ชำระค่าบริการตรวจรักษาให้แก่ท่าน บริษัทฯ
                        จะเปิดเผยข้อมูลการตรวจรักษาซึ่งเป็นข้อมูลส่วนบุคคลที่อ่อนไหวให้กับบุคคลดังกล่าวเฉพาะกรณีที่ท่านได้ให้ความยินยอมในการเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลดังกล่าวเท่านั้น
                        ถ้าท่านไม่ได้ให้ความยินยอมดังกล่าว บริษัทฯ
                        จะส่งผลตรวจรักษาให้ท่านโดยตรง
                      </p>
                    </td>
                    <td width="144" valign="top">
                      <p>- ข้อมูลระบุตัวตน</p>
                      <p>- ข้อมูลสำหรับการติดต่อ</p>
                      <p>- ข้อมูลด้านสุขภาพ</p>
                    </td>
                    <td width="149" valign="top">
                      <p>
                        เมื่อได้รับความยินยอมโดยชัดแจ้งจากท่านในการเปิดเผยข้อมูลส่วนบุคคล
                        (ม.26)
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="33" valign="top">
                      <p>
                        <strong>5.</strong>
                      </p>
                    </td>
                    <td width="275" valign="top">
                      <p>
                        <strong>
                          เพื่อวัตถุประสงค์ในการเชื่อมโยงฐานข้อมูลอิเล็กทรอนิกส์ด้านเวชระเบียนระหว่างสถานพยาบาลผ่านระบบเครือข่ายสารสนเทศ
                        </strong>
                      </p>
                      <p>
                        เมื่อท่านให้ความยินยอม บริษัทฯ
                        จะนำข้อมูลส่วนบุคคลของท่านเข้าสู่ระบบคอมพิวเตอร์ในรูปแบบเครือข่ายสารสนเทศเพื่ออำนวยความสะดวกให้ท่านในการรับคำปรึกษาผ่านแอพพลิเคชั่น
                        และเพื่อให้ท่านสามารถบริหารจัดการข้อมูลผ่านแอพพลิเคชั่นได้
                        และเพื่อให้เกิดประโยชน์สูงสุด
                        ระบบจะทำการเชื่อมโยงฐานข้อมูลอิเล็กทรอนิกส์ด้านเวชระเบียนระหว่างสถานพยาบาลในเครือข่ายเพื่อให้ท่านสามารถเรียกดูข้อมูลส่วนบุคคลของท่านที่มีอยู่กับสถานพยาบาลในเครือข่ายผ่านอุปกรณ์อิเล็กทรอนิกส์ต่างๆ
                        ได้ โดยบริษัทฯ
                        มีความตกลงร่วมกับสถานพยาบาลในเครือข่ายเพื่อคุ้มครองข้อมูลส่วนบุคคลของท่านให้เป็นไปตามที่
                        พรบ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 กำหนด
                      </p>
                    </td>
                    <td width="144" valign="top">
                      <p>- ข้อมูลระบุตัวตน</p>
                      <p>- ข้อมูลสำหรับการติดต่อ</p>
                      <p>- ข้อมูลด้านสุขภาพ</p>
                    </td>
                    <td width="149" valign="top">
                      <p>
                        เมื่อได้รับความยินยอมโดยชัดแจ้งจากท่านในการเปิดเผยข้อมูลด้านสุขภาพระหว่างสถานพยาบาล
                        (ม.26)
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="33" valign="top">
                      <p>
                        <strong>6.</strong>
                      </p>
                    </td>
                    <td width="275" valign="top">
                      <p>
                        <strong>เพื่อวัตถุประสงค์ทางการตลาดของบริษัทฯ</strong>
                      </p>
                      <p>
                        บริษัทฯ อาจทำการเก็บรวบรวม ใช้
                        และประมวลผลข้อมูลส่วนบุคคลเพื่อวิเคราะห์สภาวะสุขภาพของท่าน
                        และติดต่อเพื่อสื่อสาร ส่งข้อมูลข่าวสารด้านการแพทย์
                        และนำเสนอโปรโมชั่น สินค้าและบริการ
                        แก่ท่านตามที่ท่านได้ให้ความยินยอม
                      </p>
                    </td>
                    <td width="144" valign="top">
                      <p>- ข้อมูลระบุตัวตน</p>
                      <p>- ข้อมูลสำหรับการติดต่อ</p>
                      <p>
                        - ข้อมูลการสมัครข่าวสารและการเข้าร่วมกิจกรรมทางการตลาด
                      </p>
                    </td>
                    <td width="149" valign="top">
                      <p>
                        บริษัทฯ
                        จะดำเนินการในเรื่องนี้ได้หลังจากได้รับความยินยอมจากท่านในการให้บริษัทฯ
                        นำข้อมูลด้านสุขภาพไปใช้เพื่อวัตถุประสงค์ทางการตลาด
                        (ม.26)
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>
                นอกจากวัตถุประสงค์ที่ระบุข้างต้นแล้ว บริษัทฯ
                จะไม่นำข้อมูลส่วนบุคคลของท่านไปใช้เพื่อวัตถุประสงค์อื่น
                ยกเว้นในกรณีที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                อนุญาต เช่น
              </p>
              <ul>
                <li>
                  เมื่อได้รับความยินยอมจากท่าน (ม.24)
                  หรือเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่านในกรณีการใช้ข้อมูลส่วนบุคคลที่อ่อนไหว
                  (ม.26)
                </li>
                <li>
                  เพื่อการศึกษาวิจัยหรือสถิติซึ่งได้จัดให้มีมาตรการปกป้องที่เหมาะสมเพื่อคุ้มครองข้อมูลส่วนบุคคลสิทธิและเสรีภาพของเจ้าของข้อมูลส่วนบุคคล
                  (ม.24 (1))
                </li>
                <li>
                  เพื่อป้องกันระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพ (ม.24 (2))
                </li>
                <li>
                  เพื่อการปฏิบัติตามสัญญาระหว่างบริษัทฯ กับท่าน (ม.24 (3))
                </li>
                <li>
                  เพื่อปฏิบัติหน้าที่ในการดำเนินภารกิจเพื่อประโยชน์สาธารณะของบริษัทฯ
                  (ม.24 (4))
                </li>
                <li>
                  เพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัท (Legitimate Interest)
                  หรือของบุคคลหรือนิติบุคคลอื่น
                  เว้นแต่ประโยชน์ดังกล่าวมีความสำคัญน้อยกว่าสิทธิขั้นพื้นฐานของเจ้าของข้อมูลส่วนบุคคล
                  (ม.24 (5))
                </li>
                <li>เพื่อการปฏิบัติตามกฎหมายของบริษัทฯ (ม.24 (6))</li>
                <li>
                  เพื่อป้องกันระงับอันตรายต่อชีวิต ร่างกาย
                  หรือสุขภาพในกรณีที่การใช้ข้อมูลส่วนบุคคลที่อ่อนไหวที่เจ้าของข้อมูลส่วนบุคคลไม่สามารถให้ความยินยอมได้
                  ไม่ว่ากรณีใดก็ตาม (ม.26 (1))
                </li>
                <li>เพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย (ม.26 (4))</li>
                <li>
                  เพื่อประโยชน์ด้านสาธารณสุข
                  หรือการคุ้มครองทางสังคมอื่นใดโดยบริษัทฯ
                  จัดให้มีมาตรการที่เหมาะสมเพื่อคุ้มครองสิทธิขั้นพื้นฐานและประโยชน์ของเจ้าของข้อมูลส่วนบุคคล
                  (ม.26 (5) (ข))
                </li>
                <li>
                  เพื่อความจำเป็นในการปฏิบัติตามกฎหมายด้านการคุ้มครองแรงงาน
                  การให้สวัสดิการรักษาพยาบาล การประกันสังคม (ม.26 (5) (ค))
                </li>
              </ul>
              <p>
                <strong><u>ขอบเขต</u></strong>
              </p>
              <p>
                <strong><u>นิยาม</u></strong>
              </p>
              <p>
                <strong>“ข้อมูลส่วนบุคคล”</strong>
                หมายถึง
                ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม
                แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ
              </p>
              <p>
                <strong>“ข้อมูลส่วนบุคคลที่อ่อนไหว” </strong>
                หมายถึง ข้อมูลส่วนบุคคลที่เกี่ยวกับเชื้อชาติ เผ่าพันธุ์
                ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา
                พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ
                ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพ (เช่น
                ข้อมูลภาพจำลองใบหน้า ข้อมูลจำลองม่านตา ข้อมูลจำลองลายนิ้วมือ)
                หรือข้อมูลอื่นใดที่กระทบต่อเจ้าของข้อมูลส่วนบุคคลในทำนองเดียวกันตามที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลประกาศกำหนด
              </p>
              <p>
                <strong>“ข้อมูลการรักษาพยาบาล”</strong> หมายถึง
                ข้อมูลดังต่อไปนี้
              </p>
              <ul>
                <li>วันเดือนปีที่เข้ารับการรักษา</li>
                <li>ประวัติแพ้ยาและประวัติผลข้างเคียงจากยา</li>
                <li>ประวัติแพ้อาหาร</li>
                <li>
                  ชื่อโรคที่ได้รับการวินิจฉัย ชื่อหัตถการ และชื่อการผ่าตัด
                </li>
                <li>
                  ผลเลือด ผลตรวจทางห้องปฏิบัติการ ผลตรวจชิ้นเนื้อทางพยาธิวิทยา
                  ภาพถ่ายทางรังสีวิทยา และรายงานผลการ ทางรังสีวิทยา
                </li>
                <li>รายการยาที่แพทย์ได้สั่ง</li>
                <li>
                  ข้อมูลอื่น เช่น อาการ คำแนะนำของแพทย์
                  และรายละเอียดการวินิจฉัยโรค เป็นต้น
                </li>
              </ul>
              <p>
                <strong>“ประมวลผล”</strong>
                หมายถึง เก็บรวบรวม ใช้ หรือเปิดเผย
              </p>
              <p>
                <strong>“ผู้ควบคุมข้อมูลส่วนบุคคล”</strong>
                หมายถึง
                บุคคลหรือนิติบุคคลที่มีอํานาจในการตัดสินใจเกี่ยวกับการเก็บรวบรวม
                ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
              </p>
              <p>
                <strong>“ผู้ประมวลผลข้อมูลส่วนบุคคล”</strong>
                หมายถึง บุคคลหรือนิติบุคคลซึ่งดำเนินการเกี่ยวกับการเก็บรวบรวม
                ใช้
                หรือเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล
                ทั้งนี้
                บุคคลหรือนิติบุคคลซึ่งดำเนินการดังกล่าวไม่เป็นผู้ควบคุมข้อมูลส่วนบุคคล
              </p>
              <p>
                <strong>“กลุ่มบริษัทกรุงเทพดุสิตเวชการ”</strong>
                หมายถึง บริษัทที่อยู่ในเครือข่ายของบริษัท กรุงเทพดุสิตเวชการ
                จำกัด (มหาชน)
                ทั้งที่มีอยู่ในปัจจุบันและที่จะมีขึ้นในอนาคตไม่ว่าจะจดทะเบียนในประเทศไทยหรือในต่างประเทศ
                ซึ่งรวมถึงบริษัท กรุงเทพดุสิตเวชการ จำกัด (มหาชน) ด้วย
              </p>
              <p>
                <strong>“กลุ่มบริษัทสมิติเวช”</strong>
                หมายถึง บริษัทที่อยู่ในเครือข่ายของบริษัท สมิติเวช จำกัด (มหาชน)
                ทั้งที่มีอยู่ในปัจจุบันและที่จะมีขึ้นในอนาคตไม่ว่าจะจดทะเบียนในประเทศไทยหรือในต่างประเทศ
                ซึ่งรวมถึงบริษัท สมิติเวช จำกัด (มหาชน) ด้วย
              </p>
              <p>
                <strong>“สถานพยาบาลในเครือข่าย”</strong> หมายถึง
                สถานพยาบาลในกลุ่มหรือในเครือข่ายของบริษัท สมิติเวช จำกัด
                (มหาชน)และ บริษัท กรุงเทพดุสิตเวชการ จำกัด (มหาชน)
                ทั้งที่ประกอบกิจการในประเทศไทยและในต่างประเทศ
              </p>
              <p>
                <strong><u>หน้าที่ความรับผิดชอบ</u></strong>
              </p>
              <p>
                <strong><u>แนวทางปฏิบัติ</u></strong>
              </p>
              <p>
                <strong>1. ข้อมูลส่วนบุคคลที่บริษัทฯ เก็บรวบรวมจากท่าน</strong>
              </p>
              <p>
                ข้อมูลส่วนบุคคลของท่านที่บริษัทฯ เก็บรวบรวม
                สามารถจำแนกเป็นประเภทดังต่อไปนี้
              </p>
              <table>
                <thead>
                  <tr>
                    <th width="270">
                      <p>
                        <strong>ประเภทข้อมูลส่วนบุคคล</strong>
                      </p>
                    </th>
                    <th width="331">
                      <p>
                        <strong>รายละเอียด</strong>
                      </p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="270" valign="top">
                      <p>1. ข้อมูลระบุตัวตน (Personal data)</p>
                    </td>
                    <td width="331" valign="top">
                      <p>
                        เช่น ชื่อ นามสกุล เลขที่บัตรประชาชน ID รูปถ่ายใบหน้า เพศ
                        วันเดือนปีเกิด หนังสือเดินทาง
                        หรือหมายเลขที่ระบุตัวตนอื่น ๆ
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="270" valign="top">
                      <p>2. ข้อมูลสำหรับการติดต่อ (Contact data)</p>
                    </td>
                    <td width="331" valign="top">
                      <p>เช่น ที่อยู่ หมายเลขโทรศัพท์ อีเมล</p>
                    </td>
                  </tr>
                  <tr>
                    <td width="270" valign="top">
                      <p>3. ข้อมูลการเงิน (Financial data)</p>
                    </td>
                    <td width="331" valign="top">
                      <p>
                        เช่น ข้อมูลการเรียกเก็บเงิน ข้อมูลบัตรเครดิตหรือเดบิต
                        ข้อมูลใบเสร็จ ข้อมูลใบราคา
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="270" valign="top">
                      <p>
                        4. ข้อมูลการสมัครข่าวสารและการเข้าร่วมกิจกรรมทางการตลาด
                        (Marketing Data)
                      </p>
                    </td>
                    <td width="331" valign="top">
                      <p>
                        เช่น
                        ข้อมูลที่ใช้ในการลงทะเบียนเพื่อรับข่าวสารและเข้าร่วมกิจกรรมทางการตลาด
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="270" valign="top">
                      <p>5. ข้อมูลสถิติ (Statistical Data)</p>
                    </td>
                    <td width="331" valign="top">
                      <p>
                        เช่น ข้อมูลที่ไม่ระบุตัวตน จำนวนผู้ป่วย
                        และจำนวนการเข้าชมเว็บไซต์
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="270" valign="top">
                      <p>6. ข้อมูลจากการเข้าใช้เว็บไซต์ (Technical data)</p>
                    </td>
                    <td width="331" valign="top">
                      <p>
                        เช่น หมายเลข IP Address ของคอมพิวเตอร์ ชนิดของบราวเซอร์
                        ข้อมูล Cookies การตั้งค่าเรื่องเขตเวลา (time zone)
                        ระบบปฏิบัติการ
                        แพลตฟอร์มและเทคโนโลยีของอุปกรณ์ที่ใช้เข้าเว็บไซต์ และ
                        Online Appointment System
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="270" valign="top">
                      <p>7. ข้อมูลด้านสุขภาพ (Health data)</p>
                    </td>
                    <td width="331" valign="top">
                      <p>
                        เช่น ข้อมูลการรักษาพยาบาล
                        รายงานที่เกี่ยวกับสุขภาพกายและสุขภาพจิต
                        การดูแลสุขภาพของผู้รับบริการ ผลการทดสอบจากห้องทดลอง
                        การวินิจฉัย ชื่อโรคที่ได้รับการวินิจฉัย
                        ข้อมูลที่เกี่ยวข้องกับการใช้ยาและแพ้ยา ประวัติแพ้อาหาร
                        ผลเลือด ผลตรวจทางห้องปฏิบัติการ
                        ผลตรวจชิ้นเนื้อทางพยาธิวิทยา ภาพถ่ายทางรังสีวิทยา
                        และรายงานผลการตรวจทางรังสีวิทยารายการยาที่แพทย์ได้สั่ง
                        ข้อมูลที่จำเป็นต่อการให้บริการทางการแพทย์ ข้อมูล
                        Feedback และผลการรักษา
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>
                <strong>2. แหล่งที่มาของข้อมูลส่วนบุคคล</strong>
              </p>
              <p>
                บริษัทฯ เก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากแหล่งที่มาดังต่อไปนี้
              </p>
              <ol>
                <li>
                  <p>ข้อมูลส่วนบุคคลที่ได้โดยตรงจากท่าน ได้แก่</p>
                  <ol>
                    <li>
                      กรณีที่ท่านเป็นผู้เข้ารับบริการตรวจและรักษาโรค: บริษัทฯ
                      ได้ข้อมูลส่วนบุคคลของท่านจากการที่ท่านติดต่อสอบถามกับบริษัทฯ
                      เรื่องการบริการ
                      หรือท่านได้ลงทะเบียนเข้ารับบริการทางการแพทย์
                      และบริการต่างๆ จากบริษัทฯ ด้วยตนเองที่บริษัทฯ
                      รวมทั้งการลงทะเบียนผ่านสื่ออิเล็กทรอนิกส์
                    </li>
                    <li>
                      กรณีที่ท่านเป็นผู้ให้บริการ (Vendor) ของบริษัทฯ: บริษัทฯ
                      ได้ข้อมูลส่วนบุคคลของท่านจากการที่ท่านติดต่อสอบถามกับบริษัทฯ
                      เพื่อเข้ามาให้บริการกับบริษัทฯ หรือการที่บริษัทฯ
                      เก็บรวบรวมข้อมูลส่วนบุคคลของท่านในฐานะที่ท่านเป็นผู้ให้บริการที่เข้าทำสัญญากับบริษัทฯ
                    </li>
                  </ol>
                </li>
                <li>
                  <p>ข้อมูลส่วนบุคคลที่ได้รับโดยทางอ้อม ได้แก่</p>
                  <ol>
                    <li>
                      บุคคลที่มีความใกล้ชิดกับท่าน เช่น ญาติ คู่สมรส เป็นต้น
                    </li>
                    <li>
                      บุคคลที่ท่านมอบอำนาจให้ดำเนินการแทนตัวท่านในการติดต่อกับโรงพยาบาล
                    </li>
                    <li>
                      สถานพยาบาลในเครือข่ายในกรณีที่ท่านได้ให้ความยินยอมกับสถานพยาบาลในเครือข่ายไว้ว่าให้เปิดเผยข้อมูลส่วนบุคคลของท่านได้
                    </li>
                    <li>
                      บุคคล นิติบุคคล หรือหน่วยงานไม่ว่าภาครัฐ เอกชน
                      หรือรัฐวิสาหกิจที่เป็นผู้ส่งท่านมาตรวจรักษาหรือใช้บริการกับบริษัทฯ
                      หรือเป็นผู้ชำระค่าบริการให้กับท่าน
                    </li>
                  </ol>
                </li>
              </ol>
              <p>
                <strong>3. การเปิดเผยหรือแบ่งปันข้อมูลส่วนบุคคล</strong>
              </p>
              <p>
                บริษัทฯ จะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านให้บุคคลภายนอก
                ยกเว้นเป็นกรณีที่กฎหมายอนุญาตเพื่อความจำเป็นในการปฏิบัติงาน
                ซึ่งทำให้บริษัทฯ อาจเปิดเผยข้อมูลส่วนบุคคลได้ในกรณีต่อไปนี้
              </p>
              <ol>
                <li>
                  เปิดเผยข้อมูลส่วนบุคคลให้หน่วยงานราชการ
                  หน่วยงานผู้มีอำนาจหรือบุคคลใดๆ เมื่อมีกฎหมายกำหนดหรือให้อำนาจ
                  รวมถึงการปฏิบัติตามคำสั่งศาล
                </li>
                <li>
                  <p>
                    การเปิดเผยข้อมูลส่วนบุคคลให้กับบุคคลหรือนิติบุคคลที่บริษัทฯ
                    จำเป็นต้องปฏิบัติตามสัญญาหรือเพื่อผลประโยชน์ของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล
                    โดยบริษัทฯ
                    กำหนดให้บุคคลหรือนิติบุคคลเหล่านี้ต้องรักษาความลับและคุ้มครองข้อมูลส่วนบุคคลของท่านตามมาตรฐานที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                    พ.ศ. 2562 กำหนด
                    ซึ่งรวมถึงแต่ไม่จำกัดเพียงบุคคลหรือนิติบุคคลในข้อนี้ได้แก่
                  </p>
                  <ul>
                    <li>
                      สถานพยาบาลในเครือข่ายกลุ่มบริษัทสมิติเวชและกลุ่มบริษัทกรุงเทพดุสิตเวชการ
                      เท่าที่จำเป็นในการให้บริการการตรวจรักษาโรคและให้บริการทางการแพทย์กับท่าน
                      โดยบริษัทฯ
                      จะเปิดเผยข้อมูลส่วนบุคคลเฉพาะส่วนที่จำเป็นเท่านั้น
                      และบริษัทฯ
                      จะรักษาความลับให้กับข้อมูลส่วนบุคคลของท่านตามหน้าที่ที่บริษัทฯ
                      มีภายใต้กฎหมายที่เกี่ยวข้อง เช่น พระราชบัญญัติสถานพยาบาล
                      พ.ศ. 2541 พระราชบัญญัติสุขภาพแห่งชาติ พ.ศ. 2550
                      และพระราชบัญญัติวิชาชีพเวชกรรม พ.ศ. 2525
                    </li>
                    <li>
                      บริษัทประกันภัย
                      หรือผู้ให้บริการบริหารจัดการสินไหมทดแทนของบริษัทประกันภัยนั้น
                    </li>
                    <li>สถานพยาบาลที่รับการส่งต่อผู้ป่วย</li>
                    <p>
                      ผู้ส่งท่านมาตรวจรักษาหรือใช้บริการกับสถานพยาบาล
                      หรือชำระเงินค่าบริการแทนท่าน
                    </p>
                    <li>
                      ผู้ประมวลผลข้อมูลส่วนบุคคลที่จำเป็นต่อการปฏิบัติงานของบริษัทฯ
                      เช่น ผู้รับจ้าง หรือผู้ให้บริการตรวจทางห้องปฏิบัติการ
                      การจัดทำข้อมูล การโทรคมนาคม ระบบคอมพิวเตอร์ การชำระเงิน
                      หรือการให้บริการด้านเทคโนโลยี (Technology Outsource)
                    </li>
                  </ul>
                </li>
                <li>
                  บริษัทฯ อาจเก็บข้อมูลส่วนบุคคลไว้ในระบบประมวลผลแบบคลาวด์
                  (Cloud Computing)
                  โดยใช้บริการจากบุคคลที่สามไม่ว่าตั้งอยู่ในประเทศไทยหรือต่างประเทศ
                  โดยบริษัทฯ
                  ได้เข้าทำสัญญากับบุคคลดังกล่าวด้วยความระมัดระวังและพิจารณาถึงระบบรักษาความปลอดภัยในการเก็บรักษาข้อมูลส่วนบุคคลที่ผู้ให้บริการระบบ
                  Cloud Computing นั้นให้กับการคุ้มครองข้อมูลส่วนบุคคล
                </li>
              </ol>
              <p>
                <strong>4. ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล</strong>
              </p>
              <ol>
                <li>
                  บริษัทฯ
                  ใช้มาตรฐานระยะเวลาการเก็บเวชระเบียนตามพระราชบัญญัติสถานพยาบาล
                  พ.ศ. 2541 และฉบับแก้ไขล่าสุด โดยบริษัทฯ
                  จะเก็บเวชระเบียนขั้นต่ำ5ปีแต่ไม่เกิน 10
                  ปีนับจากวันที่มารับการรับการรักษาพยาบาลครั้งสุดท้าย
                  เมื่อครบกำหนด 10 ปีแล้วจะทำลายทิ้งทั้งเวชระเบียนฉบับจริง สำเนา
                  และเวชระเบียนรูปแบบอิเล็กทรอนิกส์
                </li>
                <li>
                  ในกรณีที่บริษัทฯ ต้องปฏิบัติตามกฎหมาย ปฏิบัติตามคำสั่งศาล
                  หรือต้องก่อตั้งสิทธิเรียกร้องตามกฎหมายเพื่อเข้ากระบวนการระงับข้อพิพาทใดๆ
                  บริษัทฯ
                  อาจจัดเก็บข้อมูลส่วนบุคคลได้ตามระยะเวลาของอายุความตามกฎหมาย
                  หรือจนกว่าข้อพิพาทนั้นจะถึงที่สุดแล้วแต่กรณี
                </li>
              </ol>
              <p>
                <strong
                  >5. มาตรการในการเก็บรักษาและประมวลผลข้อมูลส่วนบุคคล</strong
                >
              </p>
              <ol>
                <li>
                  บริษัทฯ
                  จะจัดการเก็บรักษาข้อมูลส่วนบุคคลด้วยมาตรการไม่น้อยกว่าระดับที่กฎหมายกำหนด
                  และด้วยระบบที่เหมาะสม
                  เพื่อป้องกันและรักษาความปลอดภัยข้อมูลส่วนบุคคลนั้น เช่น
                  ใช้โปรโตคอลดความปลอดภัย (Secure Sockets Layer: SSL)
                  ปกป้องด้วยไฟร์วอลล์ รหัสผ่าน และมาตรการทางเทคนิคอื่นๆ
                  สำหรับการเข้ารหัสข้อมูลผ่านทางอินเตอร์เน็ต
                  และจัดเก็บในสถานที่ที่มีระบบป้องกันการเข้าถึงที่จำกัดบุคคลที่สามารถเข้าถึงได้สำหรับข้อมูลส่วนบุคคลที่อยู่ในรูปแบบเอกสาร
                </li>
                <li>
                  บริษัทฯ
                  จำกัดการเข้าถึงข้อมูลส่วนบุคคลที่อาจจะเข้าถึงได้โดยพนักงาน
                  ตัวแทน คู่ค้า หรือบุคคลภายนอก
                  การเข้าถึงข้อมูลส่วนบุคคลของบุคคลภายนอกจะสามารถทำได้ตามเท่าที่กำหนดไว้หรือตามคำสั่ง
                  ซึ่งบุคคลภายนอกจะต้องมีหน้าที่ในการรักษาความลับและคุ้มครองข้อมูลส่วนบุคคล
                </li>
                <li>
                  บริษัทฯ
                  จัดให้มีวิธีการทางเทคโนโลยีเพื่อป้องกันไม่ให้มีการเข้าสู่ระบบคอมพิวเตอร์ที่ไม่ได้รับอนุญาต
                </li>
                <li>
                  บริษัทฯ
                  มีระบบตรวจสอบเพื่อจัดการทำลายข้อมูลส่วนบุคคลที่ไม่มีความจำเป็นในการดำเนินการของบริษัทฯ
                </li>
                <li>
                  ในกรณีที่เป็นข้อมูลส่วนบุคคลที่อ่อนไหวบริษัทฯ
                  จะจัดให้มีมาตรการการรักษาความมั่นคงปลอดภัยของข้อมูลเอกสารและข้อมูลอิเล็กทรอนิกส์ในด้านการเข้าถึงและควบคุมการใช้งาน
                  มีระบบการใช้งานและระบบสำรองพร้อมทั้งแผนสำหรับกรณีฉุกเฉิน
                  และมีการตรวจสอบประเมินความเสี่ยงของระบบอย่างสม่ำเสมอ
                </li>
              </ol>
              <p>
                <strong>6. การโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ</strong>
              </p>
              <ol>
                <li>
                  ในบางกรณี บริษัทฯ
                  อาจมีความจำเป็นต้องโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศ
                  บริษัทฯ
                  อาจดำเนินการดังกล่าวได้หลังจากที่ได้แจ้งกับท่านถึงวัตถุประสงค์ของการดำเนินการดังกล่าว
                  และได้รับการยินยอมจากท่านแล้ว โดยบริษัทฯ
                  จะแจ้งให้ท่านทราบถึงมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่อาจไม่เพียงพอของประเทศปลายทาง
                </li>
                <li>
                  บริษัทฯ
                  สามารถโอนข้อมูลส่วนบุคคลของท่านไปได้โดยไม่ต้องขอความยินยอมจากท่านในกรณีที่การโอนข้อมูลส่วนบุคคลไปต่างประเทศนั้นเป็นไปเพื่อปฏิบัติตามสัญญาซึ่งท่านเป็นคู่สัญญา
                  หรือเพื่อใช้ในการดำเนินการตามคำขอของท่านก่อนเข้าทำสัญญานั้น
                  หรือเป็นไปตามข้อกำหนดในพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                  พ.ศ. 2562
                </li>
              </ol>
              <p>
                <strong>7. นโยบายเกี่ยวกับคุกกี้ (Cookie Policy)</strong>
              </p>
              <p>
                เมื่อท่านเยี่ยมชมเว็บไซต์ของบริษัทฯ บริษัทฯ
                ใช้คุกกี้เพื่อให้มั่นใจว่าท่านจะได้รับประสบการณ์ที่ดีจากการใช้งานบนเว็บไซต์ของบริษัทฯ
                คุกกี้เป็นไฟล์ขนาดเล็กที่จัดเก็บข้อมูลและบันทึกลงไปในอุปกรณ์คอมพิวเตอร์หรือเครื่องมือสื่อสารที่เข้าใช้งานของท่านผ่านทางเว็บเบราว์เซอร์ที่ท่านเลือกใช้ในขณะที่ท่านเข้าชมเว็บไซต์
              </p>
              <p>
                บริษัทฯ
                ใช้คุกกี้เพื่อเก็บเอกลักษณ์การเข้าเยี่ยมชมเว็บไซต์ของท่านโดยเอกลักษณ์นี้ทำให้บริษัทฯ
                สามารถจำลักษณะการใช้งานเว็บไซต์ของท่านได้ง่ายขึ้น
                และข้อมูลเหล่านี้จะถูกนำไปใช้เพื่อปรับปรุงเว็บไซต์ของบริษัทฯ
                ให้เข้ากับความต้องการของท่านมากยิ่งขึ้น
                เพื่อความสะดวกและรวดเร็วในการใช้งานเว็บไซต์ท่าน ในบางครั้ง
                บริษัทฯ
                จำเป็นต้องให้บุคคลที่สามในการดำเนินการดังกล่าวซึ่งอาจต้องใช้อินเทอร์เน็ตโปรโตคอลแอดเดรส
                (IP Address) และคุกกี้เพื่อวิเคราะห์ เชื่อมโยงข้อมูล
                และประมวลผลตามวัตถุประสงค์ทางการตลาด
                ท่านสามารถตั้งค่าคุกกี้ได้เมื่อท่านเข้าสู่เว็บไซต์ของบริษัทฯ
                โดยท่านสามารถเลือกได้ว่าจะอนุญาตหรือไม่อนุญาตให้คุกกี้ทำการวิเคราะห์
                เชื่อมโยงข้อมูล และประมวลผลตามวัตถุประสงค์ทางการตลาด
              </p>
              <p>
                <strong>8. สิทธิของเจ้าของข้อมูลส่วนบุคคล</strong>
              </p>
              <p>
                ในฐานะเจ้าของข้อมูลส่วนบุคคล ท่านมีสิทธิร้องขอให้บริษัทฯ
                ดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่านตามขอบเขตที่กฎหมายอนุญาตให้กระทำได้
                ดังนี้
              </p>
              <ol>
                <li>
                  สิทธิในการเพิกถอนความยินยอม (right to withdraw consent):
                  ท่านมีสิทธิในการเพิกถอนความ
                  ยินยอมในการประมวลผลข้อมูลสวนบุคคลที่ท่านได้ให้ความยินยอมกับบริษัทฯ
                  ได้ตลอดระยะเวลาที่ ข้อมูลส่วนบุคคลของท่านอยู่กับบริษัทฯ
                </li>
                <li>
                  สิทธิในการเข้าถึงข้อมูลส่วนบุคคล (right of access):
                  ท่านมีสิทธิในการเข้าถึงข้อมูลส่วนบุคคลของ ท่านและขอให้บริษัทฯ
                  ทำสำเนาข้อมูลส่วนบุคคลดังกล่าว รวมถึงขอให้บริษัทฯ
                  เปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคลที่ท่านไม่ได้ให้ความยินยอมต่อบริษัทฯ
                  ให้แก่ท่านได้
                </li>
                <li>
                  สิทธิในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง (right to
                  rectification): ท่านมีสิทธิในการขอให้บริษัทฯ
                  แก้ไขข้อมูลที่ไม่ถูกต้อง หรือ เพิ่มเติมข้อมูลที่ไม่สมบูรณ์
                </li>
                <li>
                  สิทธิในการลบข้อมูลส่วนบุคคล (right to erasure):
                  ท่านมีสิทธิในการขอให้บริษัทฯ ทำการลบข้อมูลของ
                  ท่านด้วยเหตุบางประการได้
                </li>
                <li>
                  สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล (right to restriction of
                  processing): ท่านมีสิทธิในการให้บริษัทฯ
                  ระงับการใช้ข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้
                </li>
                <li>
                  สิทธิในการให้โอนย้ายข้อมูลส่วนบุคคล (right to data
                  portability): ท่านมีสิทธิในการโอนย้าย
                  ข้อมูลส่วนบุคคลของท่านที่ท่านให้ไว้กับบริษัทฯ
                  ไปยังผู้ควบคุมข้อมูลรายอื่น หรือตัวท่านเองด้วยเหตุบาง
                  ประการได้
                </li>
                <li>
                  สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล (right to object):
                  ท่านมีสิทธิในการคัดค้านการ
                  ประมวลผลข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้
                </li>
              </ol>
              <p>
                ท่านสามารถติดต่อมายังเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data
                Protection Officer: DPO) /
                เจ้าหน้าที่ฝ่ายคุ้มครองข้อมูลส่วนบุคคล ของเราได้ เพื่อดำเนินการ
                ยื่นคำร้องขอดำเนินการตามสิทธิข้างต้น ได้ที่
              </p>
              <p>บริษัท สมิติเวช จำกัด (มหาชน)</p>
              <p>
                สมิติเวช สุขุมวิท
                <br />
                133 สุขุมวิท 49 แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพฯ 10110
                <br />
                โทรศัพท์: 02-022-2222
                <br />
                อีเมล์: svh.dpo@samitivej.co.th
              </p>
              <p>
                สมิติเวช ศรีนครินทร์
                <br />
                133 สุขุมวิท 49 แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพฯ 10110
                <br />
                โทรศัพท์: 02-022-2222
                <br />
                อีเมล์: snh.dpo@samitivej.co.th
              </p>
              <p>
                <strong>9. การเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคล</strong>
              </p>
              <p>
                บริษัทฯ
                อาจทบทวนและเปลี่ยนแปลงนโยบายการคุ้มครองข้อมูลส่วนบุคคลในอนาคตเพื่อพัฒนาให้เกิดการคุ้มครองข้อมูลส่วนบุคคลที่ดีขึ้น
                โดยบริษัทฯ
                จะแจ้งให้ท่านทราบทุกครั้งที่มีการเปลี่ยนแปลงนโยบายดังกล่าว
              </p>
              <p>
                <strong>10. ช่องทางการติดต่อ</strong>
              </p>
              <p>
                ท่านสามารถติดต่อผู้ควบคุมข้อมูล สอบถามหรือใช้สิทธิใดๆ
                ที่เกี่ยวข้องกับข้อมูลส่วนบุคคล ได้ที่
              </p>
              <p>บริษัท สมิติเวช จำกัด (มหาชน)</p>
              <p>
                สมิติเวช สุขุมวิท
                <br />
                133 สุขุมวิท 49 แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพฯ 10110
                <br />
                โทรศัพท์: 02-022-2222
                <br />
                อีเมล์: svh.dpo@samitivej.co.th
              </p>
              <p>
                สมิติเวช ศรีนครินทร์
                <br />
                133 สุขุมวิท 49 แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพฯ 10110
                <br />
                โทรศัพท์: 02-022-2222
                <br />
                อีเมล์: snh.dpo@samitivej.co.th
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Question",
  data() {
    return {};
  },
  mounted() {
    this.accessToken = this.$cookies.get("access_token");
  },
  methods: {},
});
</script>

<style lang="scss">
/*!
* Bootstrap v3.3.7 (http://getbootstrap.com)
* Copyright 2011-2016 Twitter, Inc.
* Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)

/*# sourceMappingURL=bootstrap.min.css.map */
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}

table,
th,
td {
  border: 1px solid black;
}

th {
  text-align: center;
  vertical-align: middle;
  background-color: #dddddd;
}

th,
td {
  padding: 5px;
}

ol {
  counter-reset: item;
  list-style: none;
}
ol > li:before {
  counter-increment: item;
  content: counter(item) ". ";
  position: absolute;
  left: -2.2em;
}
ol > li > ol > li:before {
  content: counters(item, ".") " ";
}

/* increment counter */
ol > li {
  position: relative;
  margin-left: 0;
  padding-left: 0;
  margin-bottom: 0.5em;
}

.nopadding {
  padding: 0px;
}
.container-fluid {
  font-family: "Prompt", sans-serif;
  max-width: 768px;
}
a:focus,
a:hover {
  text-decoration: none;
}
.head_conditions_login {
  text-align: center;
  line-height: 20px;
  color: #000;
  font-size: 20px;
  font-weight: bold;
}
.head_conditions_login_2 {
  // line-height: 24px;
  color: #333;
  font-size: 1em;
}
.num_conditions {
  font-weight: bold;
  font-size: 20px;
  // line-height: 12px;
}
.logo_samitivej img {
  width: 55%;
}

.content_page {
  margin: 5% 0px 0px;
}
.block_partner img {
  width: 95px;
}
.block_partner {
  padding: 10px 0px;
  margin: 15px 0px 10px 0px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
img.img_info {
  width: 100%;
  margin: 100% 0px 0px 10px;
}
.btn_login {
  color: #000;
  padding: 10px 10px;
  width: 84%;
  font-size: 1.3em;
  margin-top: 40%;
  border-radius: 60px;
  background: rgba(224, 187, 132, 1);
  border-bottom: 2px solid #a78657;
  background: -moz-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(224, 187, 132, 1)),
    color-stop(0%, rgba(193, 158, 103, 1)),
    color-stop(51%, rgba(233, 212, 179, 1)),
    color-stop(100%, rgba(224, 187, 132, 1))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0bb84', endColorstr='#e0bb84', GradientType=1 );
}
.btn_login:active {
  border-radius: 60px;
  background: rgba(224, 187, 132, 1);
  border-bottom: 2px solid #a78657;
  background: -moz-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(224, 187, 132, 1)),
    color-stop(0%, rgba(193, 158, 103, 1)),
    color-stop(51%, rgba(233, 212, 179, 1)),
    color-stop(100%, rgba(224, 187, 132, 1))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0bb84', endColorstr='#e0bb84', GradientType=1 );
}
.conditions {
  color: #c9c9c9;
  text-decoration: underline;
  margin: 10px 0px;
}
.conditions:focus,
.conditions:hover {
  color: #c9c9c9;
  text-decoration: underline;
  margin: 10px 0px;
}
.footer {
  left: 0;
  bottom: 0;
  width: 100%;
  color: #cecece;
  text-align: center;
}
/*create_pass page*/
.content_createpass {
  margin-top: 40px;
}

/*login_pincode page*/
.logo_pincode img {
  width: 15%;
  margin: 0px 0px 15px;
}
/*waiting*/
.head_waiting {
  color: #cbbda9;
  font-size: 1.4em;
  text-align: center;
  margin: 30px 0px 0px;
}
.img_nurse {
  /*width: 100%;*/
  height: 200px;
  width: 200px;
  /*	border: 10px solid #f6faf9;*/
  border-radius: 100%;
}
.name_waiting {
  color: #006441;
  font-size: 1.4em;
  text-align: center;
  /*margin: 25px 0px 0px;*/
}
.position {
  font-size: 1.3em;
  color: #6a6a6a;
  text-align: center;
}
.btn_cancel_waiting {
  outline: none;
  color: #969696;
  margin: 30px 0px;
  padding: 5px 10px;
  width: 120px;
  border: none;
  font-size: 1.2em;
  border-radius: 60px;
  border-bottom: 2px solid #d8d8d8;
  background: rgba(224, 224, 224, 1);
  background: -moz-linear-gradient(
    left,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(224, 224, 224, 1)),
    color-stop(51%, rgba(237, 237, 237, 1)),
    color-stop(100%, rgba(224, 224, 224, 1))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0e0e0', endColorstr='#e0e0e0', GradientType=1 );
}
.note_waiting p {
  color: #969696;
  font-size: 1.1em;
  margin: 0px;
  line-height: 0px;
}
.text_welcome {
  margin-top: 15px;
  font-size: 1.3em;
  color: #6a6a6a;
  line-height: 20px;
}
.img_wait_loading {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  opacity: 0.6;
}
.img_wait_loading {
  position: absolute;
  width: 55%;
  top: -13px;
  left: 180px;
  opacity: 0.6;
}
/*success page */
.text_thx_success {
  font-size: 1.4em;
  line-height: 20px;
  color: #494949;
}
.logo_samitivej_success img {
  width: 28%;
  margin-bottom: 4%;
}
.btn_success {
  position: fixed;
  left: 5%;
  bottom: 0;
  width: 90%;
  text-align: center;
  color: #000;
  padding: 8px 10px;
  margin-bottom: 20px;
  font-size: 1.4em;
  border-radius: 60px;
  background: rgba(224, 187, 132, 1);
  border-bottom: 2px solid #a78657;
  background: -moz-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(224, 187, 132, 1)),
    color-stop(0%, rgba(193, 158, 103, 1)),
    color-stop(51%, rgba(233, 212, 179, 1)),
    color-stop(100%, rgba(224, 187, 132, 1))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0bb84', endColorstr='#e0bb84', GradientType=1 );
}
/*paymant page*/
.btn_payment {
  text-align: center;
  color: #000;
  padding: 10px 10px;
  margin-bottom: 10px;
  font-size: 1.4em;
  border-radius: 60px;
  background: rgba(224, 187, 132, 1);
  border-bottom: 2px solid #a78657;
  background: -moz-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(224, 187, 132, 1)),
    color-stop(0%, rgba(193, 158, 103, 1)),
    color-stop(51%, rgba(233, 212, 179, 1)),
    color-stop(100%, rgba(224, 187, 132, 1))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0bb84', endColorstr='#e0bb84', GradientType=1 );
}
.btn_confirm {
  text-align: center;
  color: #000;
  padding: 8px 10px;
  margin-bottom: 20px;
  line-height: initial;
  font-size: 1.4em;
  border-radius: 60px;
  background: rgba(224, 187, 132, 1);
  border-bottom: 2px solid #a78657;
  background: -moz-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(224, 187, 132, 1)),
    color-stop(0%, rgba(193, 158, 103, 1)),
    color-stop(51%, rgba(233, 212, 179, 1)),
    color-stop(100%, rgba(224, 187, 132, 1))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0bb84', endColorstr='#e0bb84', GradientType=1 );
}
.content_payment {
  line-height: 18px;
  margin-top: 20px;
}
.col_consultation {
  margin-top: 2px;
  padding: 0px;
}
.col_consultation img {
  width: 50px;
}
.text_consultation {
  font-size: 1.4em;
  color: #006441;
}
.number_hn {
  font-size: 1.4em;
  color: #6a6a6a;
}
.text_total_payment {
  font-size: 1.2em;
  color: #6a6a6a;
  margin-top: 5px;
}
.text_total_payment_num {
  font-size: 1.4em;
  color: #6a6a6a;
  margin-top: 5px;
}
.text_subconsultation {
  font-size: 1.2em;
  color: #6a6a6a;
  line-height: 18px;
}
.fa-calendar-alt,
.fa-user-circle {
  margin-right: 8px;
  font-size: 0.7em;
}
.input_code {
  padding: 7px 12px;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 50px;
  background: #f7f7f7;
  font-size: 1.3em;
  color: #006441;
  text-transform: uppercase;
  outline: none;
}
.col_inputcode {
  margin: 0px 0px 5px;
  padding: 0px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}
.text_subconsultation_remind {
  font-size: 1.1em;
  color: #d26776;
  line-height: 16px;
}
.col_select_payment {
  border: 2px solid #f1f1f1;
  text-align: center;
  padding: 15px 0px 10px;
  margin: 0px 6px 10px 6px;
  border-radius: 15px;
  background: #fff;
}
.col_select_payment:active {
  border: 2px solid #27954c;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
}
/*.col_select_payment:hover {
border: 2px solid #27954c;
box-shadow: 0 0 12px rgba(0,0,0,.3);
}*/
.pay_active {
  border: 2px solid #27954c;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
}
.select_payment {
  margin: 20px 0px 0px;
  color: #6a6a6a;
}
.col_select_payment img {
  width: 40px;
}
.type_card {
  width: 40px;
  margin: 5px 0px 15px;
}
.number_display_card {
  border: 1px solid #ddd;
  padding: 9px 12px;
  margin-bottom: 15px;
  border-radius: 30px;
  color: #6a6a6a;
  font-size: 1.3em;
}
.text_add_card_payment {
  font-size: 1.4em;
  margin-top: 3px;
  float: left;
  margin-left: 6px;
  color: #6a6a6a;
}
.img_addcard_payment {
  float: left;
  width: 25px;
}
.col_addcard_payment {
  margin-bottom: 20px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}
/*addcard page*/
.text_add_card {
  font-size: 1.4em;
  color: #6a6a6a;
}
.input_code_addcard {
  padding: 7px 12px;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 50px;
  font-size: 1.3em;
  color: #006441;
  text-transform: uppercase;
  outline: none;
  margin: 5px 0px 10px;
}
/*review page*/
.title_review {
  font-size: 1.4em;
  color: #006441;
  margin: 0px 0px 6px;
  font-weight: normal;
}
.sub_textreview {
  font-size: 1.2em;
  line-height: 18px;
}
.review_payment {
  padding: 12px;
  border-radius: 4px;
  background: #fff;
  margin-bottom: 15px;
  box-shadow: 0px 0px 6px 0 #c7c7c7;
}
textarea.form-control.review_block {
  background: #f4f4f4;
  box-shadow: none;
  border: 1px solid #ececec;
  font-size: 1.2em;
}
.rate_point_review img {
  width: 18%;
}
.rate_point_review {
  margin: 10px 0px;
  padding: 0px 15px;
}
.btn_success_review {
  margin-top: 30px;
  margin-left: 5px;
  text-align: center;
  color: #000;
  padding: 8px 10px;
  margin-bottom: 20px;
  font-size: 1.4em;
  border-radius: 60px;
  background: rgba(224, 187, 132, 1);
  border-bottom: 2px solid #a78657;
  background: -moz-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(224, 187, 132, 1)),
    color-stop(0%, rgba(193, 158, 103, 1)),
    color-stop(51%, rgba(233, 212, 179, 1)),
    color-stop(100%, rgba(224, 187, 132, 1))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(224, 187, 132, 1) 0%,
    rgba(193, 158, 103, 1) 0%,
    rgba(233, 212, 179, 1) 51%,
    rgba(224, 187, 132, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0bb84', endColorstr='#e0bb84', GradientType=1 );
}
.btn_pass_review {
  margin-top: 30px;
  margin-right: 5px;
  text-align: center;
  color: #000;
  padding: 8px 10px;
  margin-bottom: 20px;
  font-size: 1.4em;
  border-radius: 60px;
  border-bottom: 2px solid #a2a2a2;
  background: rgba(224, 224, 224, 1);
  background: -moz-linear-gradient(
    left,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(224, 224, 224, 1)),
    color-stop(51%, rgba(237, 237, 237, 1)),
    color-stop(100%, rgba(224, 224, 224, 1))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(224, 224, 224, 1) 0%,
    rgba(237, 237, 237, 1) 51%,
    rgba(224, 224, 224, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0e0e0', endColorstr='#e0e0e0', GradientType=1 );
}
/*payment sumtotal page*/
.col_sum_top {
  padding: 0px 0px 20px;
  border-bottom: 1px solid #ddd;
}
.col_sum_middle {
  padding: 0px 0px 10px;
  margin-top: 10px;
  border-bottom: 1px solid #ddd;
}
.text_sumtotal_payment {
  color: #c5c5c5;
  font-size: 1.3em;
  padding-bottom: 2px;
}
.num_sumtotal_payment {
  font-size: 2em;
  color: #6a6a6a;
}
.col_sub_summiddle {
  padding: 0px 5px 0px 0px;
}
.text_sub_middle_payment {
  color: #c5c5c5;
  font-size: 1.1em;
}
.num_sub_middle_payment {
  font-size: 1.4em;
  font-weight: 700;
  color: #494949;
}
/*summary page*/
.block_top_summary {
  padding: 15px 0px;
  line-height: 20px;
  background: #fff;
  box-shadow: 0px 0px 6px 0 #c7c7c7;
}
.text_top_summary {
  font-size: 1.2em;
  color: #006441;
}
.num_top_summary {
  font-size: 1.8em;
  color: #494949;
}
.content_sub_summary {
  padding: 0px 0px 10px;
  border-bottom: 1px dashed #d6d6d6;
  margin: 0px 0px 10px;
}
.text_head_summary {
  color: #b89a6e;
  font-size: 1.4em;
}
.checkmark {
  position: absolute;
  top: -2px;
  left: 5px;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ddd;
}
.list-check {
  display: inline-block;
  position: relative;
  cursor: pointer;
  font-size: 1em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding: 0px 10px 0px 36px;
  margin: 5px 0px;
  border-radius: 2px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 20px;
  width: 100%;
}
input[type="checkbox"],
input[type="radio"] {
  display: none;
}
.list-check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
label.list-check input:checked ~ .checkmark {
  border-radius: 2px;
  border: none;
  background: #03964c;
}
.list-check .checkmark:after {
  left: 4px;
  top: 0px;
  width: 7px;
  height: 12px;
  border: solid #85d942;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/*register page*/
.input_register {
  padding: 7px 12px;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 50px;
  font-size: 1.3em;
  /*text-transform: uppercase;*/
  outline: none;
  margin: 8px 0px 10px;
}
.input_register:focus {
  border-color: #d2b486;
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: 0px 0px 2px 0 rgb(241, 233, 210);
}
.head_register {
  color: #494949;
  font-size: 1.4em;
  text-align: center;
  margin: 20px 0px 20px;
}
.styled-select select {
  background: transparent;
}
.date_regis select {
  padding: 7px 12px 10px;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 50px;
  font-size: 1.3em;
  text-transform: uppercase;
  outline: none;
  margin: 8px 0px 10px;
}
.copy_right {
  left: 0;
  bottom: 0;
  width: 100%;
  color: #cecece;
  text-align: center;
}
/*verify page*/
.title_verify {
  font-size: 1.8em;
  line-height: 30px;
}
.input_verify {
  border: none;
  padding: 5px 12px;
  border-bottom: 1px solid #ddd;
  background: transparent;
  outline: none;
  font-size: 1.4em;
  text-transform: uppercase;
}
.input_verify_confirm {
  border: none;
  padding: 5px 12px;
  border-bottom: 1px solid #ddd;
  background: transparent;
  outline: none;
  font-size: 1.4em;
  text-transform: uppercase;
  text-align: center;
}
.left_number {
  padding: 8px 5px;
  border-bottom: 1px solid #ddd;
  margin-right: 10px;
  font-size: 1.4em;
}
.input_verify::-webkit-input-placeholder {
  color: #dadada;
} /* WebKit, Blink, Edge */
.input_verify:-moz-placeholder {
  color: #dadada;
} /* Mozilla Firefox 4 to 18 */
.input_verify::-moz-placeholder {
  color: #dadada;
} /* Mozilla Firefox 19+ */
.input_verify:-ms-input-placeholder {
  color: #dadada;
} /* Internet Explorer 10-11 */
.input_verify::-ms-input-placeholder {
  color: #dadada;
} /* Microsoft Edge */

.input_verify_confirm::-webkit-input-placeholder {
  color: #dadada;
} /* WebKit, Blink, Edge */
.input_verify_confirm:-moz-placeholder {
  color: #dadada;
} /* Mozilla Firefox 4 to 18 */
.input_verify_confirm::-moz-placeholder {
  color: #dadada;
} /* Mozilla Firefox 19+ */
.input_verify_confirm:-ms-input-placeholder {
  color: #dadada;
} /* Internet Explorer 10-11 */
.input_verify_confirm::-ms-input-placeholder {
  color: #dadada;
} /* Microsoft Edge */

@media (min-width: 1024px) {
  .btn_login {
    margin-top: 20%;
  }
  .logo_samitivej img {
    width: 20%;
  }
  .img_wait_loading {
    position: absolute;
    width: 55%;
    top: -13px;
    /*left: 180px !important;*/
    opacity: 0.6;
  }
  .rate_point_review img {
    width: 5%;
  }
}

@media (min-width: 768px) {
  .btn_login {
    margin-top: 20%;
  }
  .logo_samitivej img {
    width: 20%;
  }
  .img_wait_loading {
    position: absolute;
    width: 55%;
    top: -22px;
    left: 130px;
    opacity: 0.6;
  }
  .rate_point_review img {
    width: 5%;
  }
  img.img_info {
    width: 80% !important;
    margin: 35% 0px 0px 10px;
  }
}
@media (max-width: 465px) and (min-width: 320px) {
  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: #cecece;
    text-align: center;
  }
  img.img_info {
    width: 100%;
    margin: 32px 0px 0px 10px;
  }
  .logo_pincode img {
    width: 150px;
    margin: 0px 0px 15px;
  }
  .img_nurse {
    height: 150px;
    width: 150px;
    object-fit: cover;
    object-position: top center;
  }
  .logo_samitivej_success img {
    width: 120px;
    margin-bottom: 6%;
  }
  .img_wait_loading {
    position: absolute;
    width: 100%;
    top: -15px;
    left: -1px;
    opacity: 0.6;
  }
}

.border-inner-box {
  border: 3px solid #9fceb2;
  border-radius: 5px;
  height: 35vh;
  padding: 0px 10px;
}

.after-box {
  clear: left;
}

.border_line {
  border-right: 1px solid #9e9e9e;
}

.border_detail {
  /*padding-left: 20px;*/
  /* border-right: 3px solid #9FCEB2;
border-bottom: 3px solid #9FCEB2; */
}

.doc_content {
  margin-top: 20px;
}

.block {
  border-radius: 5px;
  border: 3px solid #9fceb2;
  margin-left: 10px;
  position: fixed;
  width: 92%;
  height: 15%;
}
h1.title_header {
  margin-top: 0px;
  margin-bottom: 0px;
}

.square {
  background-color: #006540;
  color: #fff;
  font-size: 16px;
  border: 1px;
  border-radius: 6px;
  box-shadow: 2px 2px 5px black;
  padding: 3px;
}

@media (min-width: 466px) {
  .img_nurse {
    height: 200px !important;
    width: 200px !important;
    object-fit: cover;
    object-position: top center;
  }
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
